import React, { useState } from 'react';
import Icon from 'components/styleguide/icon/Icon';
import Tooltip from 'components/styleguide/tooltip/Tooltip';

const styles = require('./addon_info_tooltip.module.scss');

let triggerIdCounter = 0;

export default function AddonInfoTooltip({ text }: { text: string }) {
  const [triggerId] = useState(() => `addon-info-trigger-${++triggerIdCounter}`);

  return (
    <>
      <Icon
        id={triggerId}
        name="info"
        size="sm"
        color="company-text-base"
        tabIndex={0}
        aria-label="More info"
        className={styles.trigger}
      />
      <Tooltip
        targetId={triggerId}
        popoverClassName={styles.popover}
        stopPropagation
      >
        {text}
      </Tooltip>
    </>
  );
}
